import { EpimsBaseEntityDto } from './epim-base.dto';
export class LandTitleNameDto extends EpimsBaseEntityDto {
 LandTitleNameId: string;
 LandTitleName: string;
 LandTitleRemarks: string;
 LandTitleId: string;

}
